/* lib */
import { transform, wrap, frame } from "motion";

export default () => ({
  activeIndex: 0,
  minElements: 0,
  maxElements: 7,
  speedInMs: 5000,
  interval: null,
  startTime: null,
  endTime: null,
  remaining: null,
  /* when mounted */
  init() {
    /* start timeout */
    this.createInterval();
    /* start animation frame */
    frame.update(() => {
      const transformer = transform([this.startTime, this.endTime], [0, 1]);
      this.remaining = transformer(Date.now());
    }, true);
  },
  destroy() {
    this.cleanup();
  },
  /* getters */
  get currentIndex() {
    return this.activeIndex;
  },
  /* setters */
  set currentIndex(value) {
    const indexWrapper = wrap(this.minElements, this.maxElements, value);
    this.activeIndex = indexWrapper;
  },
  /* methods */
  nextItem() {
    this.currentIndex += 1;
    this.cleanup();
    this.createInterval();
  },
  prevItem() {
    this.currentIndex -= 1;
    this.cleanup();
    this.createInterval();
  },
  goTo(index) {
    if (this.currentIndex === index) return;
    this.currentIndex = index;
    this.cleanup();
    this.createInterval();
  },
  getItemStyles(index) {
    if (this.currentIndex === index) {
      return { width: "100%" };
    }
    return { width: "10%" };
  },
  getProgressStyles(index) {
    if (this.currentIndex === index) {
      return { transform: `scaleX(${this.remaining})` };
    }
    return { transition: "transform .8s ease-in-out", transformOrigin: "right", transform: "scaleX(0)" };
  },
  createInterval() {
    this.startTime = Date.now();
    this.endTime = this.startTime + this.speedInMs;

    this.interval = setInterval(() => {
      this.nextItem();
    }, this.speedInMs);
  },
  cleanup() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
  },
});
